import { createRouter, createWebHistory } from 'vue-router'
import { supabase } from '@/lib/supabase'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import ProfileView from '../views/ProfileView.vue'
import PublicProfileView from '../views/PublicProfileView.vue'
import AuthCallback from '../views/AuthCallback.vue'
import FeedView from '../views/FeedView.vue'
import PostView from '../views/PostView.vue'
import NotificationsView from '../views/NotificationsView.vue'
import AdminDashboard from '../views/AdminDashboard.vue'
import ReportIssueView from '../views/ReportIssueView.vue'
import TournamentRoomsView from '../views/TournamentRoomsView.vue'
import TournamentRoomDetailView from '../views/TournamentRoomDetailView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    meta: { auth: true },
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    meta: { auth: true },
    component: RegisterView
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView
  },
  {
    path: '/feed',
    name: 'feed',
    component: FeedView
  },
  {
    path: '/post/:id',
    name: 'post',
    component: PostView
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationsView
  },
  {
    path: '/report',
    name: 'report',
    component: ReportIssueView
  },
  {
    path: '/tournament',
    name: 'tournament',
    component: TournamentRoomsView
  },
  {
    path: '/tournament/room/:id',
    name: 'tournament-room',
    component: TournamentRoomDetailView
  },
  {
    path: '/admin',
    name: 'admin',
    meta: { requiresAdmin: true },
    component: AdminDashboard
  },
  {
    path: '/u/:handle',
    name: 'public-profile',
    component: PublicProfileView
  },
  {
    path: '/auth/callback',
    name: 'auth-callback',
    component: AuthCallback
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) return { ...savedPosition, behavior: 'smooth' }
    return { top: 0, left: 0, behavior: 'smooth' }
  }
})

router.beforeEach(async (to, _from, next) => {
  if (to.path === '/') {
    const { data } = await supabase.auth.getSession()
    if (data?.session?.user) {
      return next('/feed')
    }
  }
  if (to.meta?.requiresAdmin) {
    const { data } = await supabase.auth.getSession()
    const user = data?.session?.user
    if (!user) {
      return next('/login')
    }
    const { data: profile } = await supabase.from('profiles').select('role, status').eq('id', user.id).maybeSingle()
    if (!profile || profile.status === 'banned') {
      return next('/login')
    }
    if (profile.role !== 'admin') {
      return next('/feed')
    }
  }
  // Force data reload by triggering page refresh behavior
  // This ensures fresh data loads for every navigation
  return next()
})

export default router
